var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.2404 4.42667C13.0793 5.26586 13.6506 6.33496 13.8819 7.49879C14.1133 8.66263 13.9943 9.86893 13.5402 10.9652C13.086 12.0614 12.3169 12.9984 11.3303 13.6576C10.3436 14.3168 9.18368 14.6686 7.99707 14.6686C6.81047 14.6686 5.65051 14.3168 4.66386 13.6576C3.6772 12.9984 2.90817 12.0614 2.45398 10.9652C1.9998 9.86893 1.88087 8.66263 2.11222 7.49879C2.34357 6.33496 2.91482 5.26586 3.75374 4.42667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33334V8.00001",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.b5e1d23490c4d78c1d11c127b2a3404f.svg";
export { ForwardRef as ReactComponent };